import React from 'react';
import { createGlobalStyle } from 'styled-components';
import TopMenu from './menu/Top_menu';
import Home from './menu/Home';
import UserCount from './menu/user_count';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #ffffff;
    color: #111111;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  html {
    scroll-behavior: smooth;
  }
`;

function App() {
  const path = window.location.pathname.replace(/\/$/, '');
  if (path === '/user_count' || path.startsWith('/user_count/')) {
    return <><GlobalStyle /><UserCount /></>;
  }

  return (
    <>
      <GlobalStyle />
      <TopMenu />
      <Home />
    </>
  );
}

export default App;
